import { emptyList1g2z5xcrvp2zy as emptyList } from './CollectionsKt.mjs';
import { Paire9pteg33gng7 as Pair } from '../Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toList(_this__u8e3s4) {
  if (_this__u8e3s4.get_size_woubt6_k$() === 0)
    return emptyList();
  var iterator = _this__u8e3s4.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    return emptyList();
  var first = iterator.next_20eer_k$();
  if (!iterator.hasNext_bitz1p_k$()) {
    // Inline function 'kotlin.collections.toPair' call
    var tmp$ret$0 = new (Pair())(first.get_key_18j28a_k$(), first.get_value_j01efc_k$());
    return listOf(tmp$ret$0);
  }
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(_this__u8e3s4.get_size_woubt6_k$());
  // Inline function 'kotlin.collections.toPair' call
  var tmp$ret$1 = new (Pair())(first.get_key_18j28a_k$(), first.get_value_j01efc_k$());
  result.add_utx5q5_k$(tmp$ret$1);
  do {
    // Inline function 'kotlin.collections.toPair' call
    var this_0 = iterator.next_20eer_k$();
    var tmp$ret$2 = new (Pair())(this_0.get_key_18j28a_k$(), this_0.get_value_j01efc_k$());
    result.add_utx5q5_k$(tmp$ret$2);
  }
   while (iterator.hasNext_bitz1p_k$());
  return result;
}
//region block: exports
export {
  toList as toList2zksu85ukrmi,
};
//endregion

//# sourceMappingURL=_Maps.mjs.map
